/** @jsxImportSource @emotion/react */
import { CSSObject } from '@emotion/styled'
import { css } from '@emotion/react'
import estyled from '@signal/theme/emotion'
import { darken } from '@material-ui/core'
import {
  getColorBackgroundSelector,
  getColorGreySelector,
  getColorPrimarySelector,
  getSpacingSelector,
  paletteDividerSelector as paletteDividerSelectorRaw
} from '@signal/theme/selectors'
import { MENU_PADDING_SELECTOR, MENU_PADDING_SELECTOR_SMALL } from '../styles'

/* PopupWrapper removed - positioning now handled inline with motion.div and layoutId */

const paletteDividerSelector = paletteDividerSelectorRaw as unknown as CSSObject

export const PopupContainer = estyled.div<{ $maxHeight: string }>`
  position: relative;
  left: 0px;
  background-color: ${({ theme }) => theme.palette.background.paper};
  border-radius: 25px;
  border: 1px solid ${paletteDividerSelector};
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.05);
  padding: ${getSpacingSelector(MENU_PADDING_SELECTOR)}px;
  min-width: 200px;
  max-width: 280px;
  overflow-y: auto;
  backdrop-filter: blur(8px);
  margin-left: ${getSpacingSelector(MENU_PADDING_SELECTOR)}px;
  max-height: ${({ $maxHeight }) => $maxHeight};
`

export const PopupHeader = estyled.div<{ $hasSubItems?: boolean }>`
  padding: ${getSpacingSelector(MENU_PADDING_SELECTOR_SMALL)}px
    ${getSpacingSelector(MENU_PADDING_SELECTOR)}px;

  margin-bottom: ${({ $hasSubItems }) =>
    $hasSubItems ? getSpacingSelector(MENU_PADDING_SELECTOR_SMALL) : 0}px;

  > * {
    font-size: 16px !important;
    font-weight: 600 !important;
    color: ${getColorGreySelector(700)} !important;
  }
`

export const PopupSubItemsContainer = estyled.div`
  display: flex;
  flex-direction: column;
  gap: ${getSpacingSelector(MENU_PADDING_SELECTOR_SMALL)}px;
`

// anchor rather than a div, for the same hyperlink behavior as SubItem
export const PopupSubItem = estyled.a<{ $isActive?: boolean }>`
  color: inherit;
  text-decoration: none;

  display: flex;
  flex-direction: row;
  padding: ${getSpacingSelector(MENU_PADDING_SELECTOR)}px
    ${getSpacingSelector(MENU_PADDING_SELECTOR)}px;
  border-radius: 20px;
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    color 0.15s ease;

  ${({ $isActive, theme }) =>
    $isActive
      ? css`
          background-color: ${getColorBackgroundSelector('lightBlue')(theme)};

          > * {
            color: ${getColorPrimarySelector()(theme)} !important;
            font-weight: 600 !important;
          }

          &:hover {
            background-color: ${darken(
              getColorBackgroundSelector('lightBlue')(theme),
              0.1
            )};

            > * {
              color: ${getColorPrimarySelector()(theme)} !important;
            }
          }
        `
      : css`
          &:hover {
            background-color: ${getColorBackgroundSelector('lightBlue')(theme)};

            > * {
              color: ${getColorPrimarySelector()(theme)} !important;
            }
          }
        `}

  &:active {
    transform: scale(0.98);
    transition: transform 0.1s ease;
  }
`
